import { allReferencesQuery } from '../../catalogs/queries';
import type { ItinerariesBySessionIds } from '../../domain/Itinerary';
import type { SessionId } from '../../domain/Session';
import { setModalToDisplay, unsetModalToDisplay } from '../../legacy/actions/modals';
import { SessionsModalTypes } from '../../legacy/reducers/modals';
import referenceResolver from '../../legacy/utils/referenceResolver';
import { selectedGradeReferenceQuery } from '../../networkMap/queries';
import { createCommand } from '../../utils';
import { itinerariesBySessionIdsUpdated, moduleName } from '../state';

export type LoadItineraryForOneSessionCommandArgs = {
    sessionId: SessionId;
};

export const LoadItineraryForOneSessionCommand = createCommand(
    `${moduleName}/LOAD_ITINERARY_FOR_ONE_SESSION`,
    async ({ sessionId }: LoadItineraryForOneSessionCommandArgs, { dispatch, extra, getState }) => {
        dispatch(setModalToDisplay(SessionsModalTypes.REFRESH_ALL_SESSIONS_GRADE_LOADING));

        const rubricReferences = allReferencesQuery(getState());
        const selectedGradeReference = selectedGradeReferenceQuery(getState());
        const resolvedKey = selectedGradeReference ? referenceResolver(selectedGradeReference) : 'AGGREGATE';

        let itineraryBySessionId: ItinerariesBySessionIds;

        if (!selectedGradeReference || selectedGradeReference === 'AGGREGATE') {
            itineraryBySessionId = await extra.externalSessions.loadAggregateItineraryForOneSession(
                sessionId,
                rubricReferences.map((r) => r.key),
            );
        } else {
            // Check if the selected reference is a parent category (has child references)
            const selectedRef = rubricReferences.find((r) => r.key === resolvedKey);
            const childRefs = selectedRef
                ? rubricReferences.filter((r) => r.parentId === selectedRef.id)
                : [];

            if (childRefs.length > 0) {
                // Parent category selected — aggregate over its children
                const aggregateResult = await extra.externalSessions.loadAggregateItineraryForOneSession(
                    sessionId,
                    childRefs.map((c) => c.key),
                );
                // Remap fractions from 'AGGREGATE' key to the parent key so useFractions can find it
                const [resultSessionId, sessionData] = Object.entries(aggregateResult)[0];
                itineraryBySessionId = {
                    [resultSessionId]: {
                        ...sessionData,
                        fractions: { [resolvedKey]: sessionData.fractions['AGGREGATE'] },
                    },
                };
            } else {
                itineraryBySessionId = await extra.externalSessions.loadReferenceItineraryForOneSession(
                    sessionId,
                    resolvedKey,
                );
            }
        }

        dispatch(itinerariesBySessionIdsUpdated(itineraryBySessionId));
        dispatch(unsetModalToDisplay());
    },
);
